import React from 'react'

const GooglePlayIcon = ({ size = 16, className = '' }) => {
  return (
    <img
      src="/assets/images/500px-Google_Play_2022_icon.svg.png"
      alt="Google Play"
      className={className}
      style={{ width: size, height: size }}
    />
  )
}

export default GooglePlayIcon
